/**
 * 地図JSON取得
 */
import Repository from "../JsonRepository";
import logger from "../../lib/logger";

const resource = "";

export default {
  /**
   * 市町村判定情報
   */
  getTownList() {
    let path = "map/twn/twnarea.json";
    logger.debug("json getTownList(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 都道府県判定情報
   */
  getPrefList() {
    let path = "map/pref/prefarea.json";
    logger.debug("json getPrefList(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 市町村別河川情報
   * @param {*} twnCd 市町村コード
   */
  getRiverInfo(twnCd) {
    let path = "map/rvr/" + twnCd + ".json";
    logger.debug("json getRiverInfo(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 市町村経緯度範囲情報
   * @param {*} twnCd 市町村コード
   */
  getTwnPos(twnCd) {
    let path = "map/twn/pos/" + twnCd + ".json";
    logger.debug("json getTwnPos(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
};
